import { Fragment, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../Parametrizaciones.js';

const WATERMARK_IMAGE_SRC = "/imagesmain/superbienes_logo_main.png";

// Función para aplicar la marca de agua
const addWatermark = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                const watermark = new Image();
                watermark.src = WATERMARK_IMAGE_SRC;
                watermark.onload = () => {
                    const scale = 0.70;
                    const watermarkWidth = canvas.width * scale;
                    const watermarkHeight = (watermark.height / watermark.width) * watermarkWidth;

                    ctx.globalAlpha = 0.4;

                    const x = (canvas.width - watermarkWidth) / 2;
                    const y = (canvas.height - watermarkHeight) / 2;

                    ctx.drawImage(watermark, x, y, watermarkWidth, watermarkHeight);
                    ctx.globalAlpha = 1.0;

                    const outputType = file.type || 'image/jpeg';
                    canvas.toBlob((blob) => {
                        if (!blob) {
                            resolve(file);
                            return;
                        }
                        const newFile = new File([blob], file.name, {
                            type: outputType,
                            lastModified: Date.now()
                        });
                        resolve(newFile);
                    }, outputType, 0.9);
                };

                watermark.onerror = () => {
                    console.error("No se pudo cargar la marca de agua. Usando original.");
                    resolve(file);
                };
            };
            img.onerror = () => resolve(file);
        };
        reader.onerror = () => resolve(file);
    });
};

function AdminPropiedad() {
    const [listInmueble, setListInmueble] = useState([]);
    const navigate = useNavigate();
    const [valor, setValor] = useState('');
    const [tipoOp, setTipoOp] = useState('');
    const [loading, setLoading] = useState(false);

    const [imagenPrincipal, setImagenPrincipal] = useState(null);
    const [imagenesSecundarias, setImagenesSecundarias] = useState([]);

    // ESTADO PARA MODIFICAR
    const [inmuebleEditar, setInmuebleEditar] = useState(null);

    // --- ESTADOS DINÁMICOS CON LOCALSTORAGE ---

    // 1. Municipios
    const [listaMunicipios, setListaMunicipios] = useState(() => {
        const guardados = localStorage.getItem('listaMunicipios');
        return guardados ? JSON.parse(guardados) : [
            "Medellin", "Envigado", "Sabaneta", "Rionegro", "Bello", "Itagüi", "Guarne", "El Retiro", "Marinilla", "Llano Grande"
        ];
    });
    const [nuevoMunicipio, setNuevoMunicipio] = useState('');

    // 2. Tipos de Inmueble
    const [listaTipos, setListaTipos] = useState(() => {
        const guardados = localStorage.getItem('listaTipos');
        return guardados ? JSON.parse(guardados) : [
            "Apartamento", "Bodegas", "Casas", "Locales", "Lotes", "Fincas", "Oficinas"
        ];
    });
    const [nuevoTipo, setNuevoTipo] = useState('');

    // 3. Barrios
    const [listaBarrios, setListaBarrios] = useState(() => {
        const guardados = localStorage.getItem('listaBarrios');
        return guardados ? JSON.parse(guardados) : [
            "El Poblado", "Robledo", "Belen", "Prado", "Centro", "Manrique", "Buenos Aires",
            "Villa Hermosa", "La America", "Cabañitas", "Pedregal", "San Javier", "Laureles",
            "Estadio", "Aranjuez", "Castilla", "La Candelaria", "Guayabal", "El Escobero", "Las Palmas"
        ];
    });
    const [nuevoBarrio, setNuevoBarrio] = useState('');


    // --- FUNCIONES PARA AGREGAR OPCIONES ---

    const agregarMunicipio = () => {
        if (nuevoMunicipio.trim() && !listaMunicipios.includes(nuevoMunicipio.trim())) {
            const nuevaLista = [...listaMunicipios, nuevoMunicipio.trim()];
            setListaMunicipios(nuevaLista);
            localStorage.setItem('listaMunicipios', JSON.stringify(nuevaLista));
            setNuevoMunicipio('');
        }
    };

    const agregarTipo = () => {
        if (nuevoTipo.trim() && !listaTipos.includes(nuevoTipo.trim())) {
            const nuevaLista = [...listaTipos, nuevoTipo.trim()];
            setListaTipos(nuevaLista);
            localStorage.setItem('listaTipos', JSON.stringify(nuevaLista));
            setNuevoTipo('');
        }
    };

    const agregarBarrio = () => {
        if (nuevoBarrio.trim() && !listaBarrios.includes(nuevoBarrio.trim())) {
            const nuevaLista = [...listaBarrios, nuevoBarrio.trim()];
            setListaBarrios(nuevaLista);
            localStorage.setItem('listaBarrios', JSON.stringify(nuevaLista));
            setNuevoBarrio('');
        }
    };


    // --- FUNCIONES PARA ELIMINAR OPCIONES ---

    const eliminarMunicipio = () => {
        const municipioSeleccionado = document.getElementsByName('municipio')[0]?.value;
        if (municipioSeleccionado && listaMunicipios.includes(municipioSeleccionado)) {
            const nuevaLista = listaMunicipios.filter(muni => muni !== municipioSeleccionado);
            setListaMunicipios(nuevaLista);
            localStorage.setItem('listaMunicipios', JSON.stringify(nuevaLista));
        }
    };

    const eliminarTipo = () => {
        const tipoSeleccionado = document.getElementsByName('tipo_inmueble')[0]?.value;
        if (tipoSeleccionado && listaTipos.includes(tipoSeleccionado)) {
            const nuevaLista = listaTipos.filter(tipo => tipo !== tipoSeleccionado);
            setListaTipos(nuevaLista);
            localStorage.setItem('listaTipos', JSON.stringify(nuevaLista));
        }
    };

    const eliminarBarrio = () => {
        const barrioSeleccionado = document.getElementsByName('barrio')[0]?.value;
        if (barrioSeleccionado && listaBarrios.includes(barrioSeleccionado)) {
            const nuevaLista = listaBarrios.filter(barrio => barrio !== barrioSeleccionado);
            setListaBarrios(nuevaLista);
            localStorage.setItem('listaBarrios', JSON.stringify(nuevaLista));
        }
    };


    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        if (!token) {
            navigate('/controllers/Masterinc');
        } else {
            handleTable();
        }
    }, [navigate]);

    const formatearPesos = (numero) => {
        if (!numero) return '';
        const limpio = String(numero).replace(/\D/g, '');
        if (!limpio) return '';
        const numeroEntero = parseInt(limpio, 10);
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
        }).format(numeroEntero);
    };

    const handleChangePrecio = (e) => {
        setValor(formatearPesos(e.target.value));
    };

    const handleEditChangePrecio = (e) => {
        const valFormatted = formatearPesos(e.target.value);
        setInmuebleEditar({ ...inmuebleEditar, PRECIO: valFormatted });
    };

    const selectedMainPhoto = e => {
        if (e.target.files && e.target.files[0]) {
            setImagenPrincipal(e.target.files[0]);
        }
    };

    const selectedMultiples = e => {
        if (e.target.files) {
            setImagenesSecundarias(Array.from(e.target.files));
        }
    };

    // 1. CONSULTAR TODOS LOS INMUEBLES
    const handleTable = async () => {
        try {
            const res = await fetch(`${API_URL}?action=allInmuebles`);
            const data = await res.json();

            if (Array.isArray(data)) {
                setListInmueble(data);
            } else {
                setListInmueble([]);
            }
        } catch (err) {
            console.error("Error al obtener la lista de inmuebles:", err);
            setListInmueble([]);
        }
    };

    // 2. GUARDAR PROPIEDAD E IMÁGENES
    const SubmitAllImages = async (event) => {
        event.preventDefault();

        if (!tipoOp) {
            alert("Por favor selecciona la opción del inmueble (Arriendo o Venta).");
            return;
        }

        setLoading(true);
        const data = new FormData(event.target);
        const codigo = data.get('codigo');

        try {
            let mainImageWithCode = null;
            if (imagenPrincipal) {
                const watermarkedMain = await addWatermark(imagenPrincipal);
                mainImageWithCode = new File(
                    [watermarkedMain],
                    `${codigo}_${imagenPrincipal.name}`,
                    { type: imagenPrincipal.type || 'image/jpeg' }
                );
            }

            const renamedImages = await Promise.all(
                imagenesSecundarias.map(async (img) => {
                    const watermarkedSec = await addWatermark(img);
                    return new File(
                        [watermarkedSec],
                        `${codigo}_${img.name}`,
                        { type: img.type || 'image/jpeg' }
                    );
                })
            );

            const admPropiedades = {
                opcion: tipoOp,
                conditions: tipoOp,
                tipo_inmueble: data.get('tipo_inmueble'),
                municipio: data.get('municipio'),
                barrio: data.get('barrio'),
                habitaciones: data.get('habitaciones'),
                banos: data.get('banos'),
                parqueadero: data.get('parqueadero'),
                area: data.get('area'),
                precio: valor,
                codigo: codigo,
                descripcion: data.get('descripcion'),
                tipoimagen: mainImageWithCode?.type || 'image/jpeg',
                imagen_principal: mainImageWithCode?.name || null,
            };

            for (let i = 0; i < 20; i++) {
                admPropiedades[`imagen_${String(i + 1).padStart(2, '0')}`] = renamedImages[i]?.name || null;
            }

            const res1 = await fetch(`${API_URL}?action=guardarInmueble`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(admPropiedades)
            });

            if (!res1.ok) throw new Error("Error en el servidor al guardar datos");

            const allImages = [mainImageWithCode, ...renamedImages].filter(Boolean);

            for (const file of allImages) {
                const imgFormData = new FormData();
                imgFormData.append('image', file);
                imgFormData.append('codigo', codigo);

                await fetch(`${API_URL}?action=subirImagen`, {
                    method: 'POST',
                    body: imgFormData
                });
            }

            alert("Propiedad e imágenes guardadas correctamente.");
            event.target.reset();
            setValor('');
            setTipoOp('');
            setImagenPrincipal(null);
            setImagenesSecundarias([]);

            handleTable();

        } catch (error) {
            console.error('Error al guardar propiedad:', error);
            alert("Ocurrió un error al guardar la propiedad.");
        } finally {
            setLoading(false);
        }
    };

    // 3. ELIMINAR INMUEBLE
    const clickDelete = async (codigoInm) => {
        if (!window.confirm(`¿Estás seguro de eliminar el inmueble código ${codigoInm}?`)) return;

        try {
            const formData = new FormData();
            formData.append('codigo', codigoInm);

            const response = await fetch(`${API_URL}?action=eliminarInmueble`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                alert("Propiedad eliminada correctamente.");
                handleTable();
            } else {
                throw new Error("No se pudo eliminar");
            }
        } catch (error) {
            console.error('Error al eliminar la propiedad:', error);
            alert("Error al eliminar la propiedad.");
        }
    };

    // 4. ABRIR FORMULARIO DE EDICIÓN
    const openEditModal = (inmueble) => {
        setInmuebleEditar({ ...inmueble });
    };

    // 5. GUARDAR ACTUALIZACIÓN DESDE EL MODAL
    const clickEditable = async (e) => {
        e.preventDefault();
        if (!inmuebleEditar) return;

        const formData = new FormData();
        formData.append('parms_codigo', inmuebleEditar.CODIGO_INMUEBLE);
        formData.append('parms_opcion', inmuebleEditar.OPCION_INMUEBLE || '');
        formData.append('parms_tipo', inmuebleEditar.TIPO_INMUEBLE || '');
        formData.append('parms_municipio', inmuebleEditar.MUNICIPIO || '');
        formData.append('parms_barrio', inmuebleEditar.BARRIO || '');
        formData.append('parms_habitaciones', inmuebleEditar.HABITACIONES || '');
        formData.append('parms_banos', inmuebleEditar.BANOS || '');
        formData.append('parms_parqueadero', inmuebleEditar.PARQUEADERO || '');
        formData.append('parms_area', inmuebleEditar.AREA || '');
        formData.append('parms_precio', inmuebleEditar.PRECIO || '');
        formData.append('parms_descripcion', inmuebleEditar.DESCRIPCION || '');

        try {
            const res = await fetch(`${API_URL}?action=actualizarInmueble`, {
                method: 'POST',
                body: formData
            });

            if (!res.ok) throw new Error("Error en la actualización");

            await res.text();

            setListInmueble((prevList) =>
                prevList.map((item) =>
                    item.CODIGO_INMUEBLE === inmuebleEditar.CODIGO_INMUEBLE
                        ? { ...item, ...inmuebleEditar }
                        : item
                )
            );

            alert("Propiedad modificada correctamente.");
            setInmuebleEditar(null);

        } catch (err) {
            console.error('Error al modificar la propiedad:', err);
            alert("Error al modificar la propiedad.");
        }
    };

    return (
        <Fragment>
            <div className="aa-title">
                <div className="container">
                    <br />
                    <a href='/controllers/masterinc'>
                        <svg width="50" height="50" fill="currentColor" className="bi bi-house-fill" viewBox="0 0 16 16" style={{ color: '#59abe3' }}>
                            <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                            <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
                        </svg>
                    </a>
                    <h2>Administrar Propiedad</h2>
                </div>
                <br />
                <div className="container">
                    <div className="panel-group" id="accordion">

                        {/* FORMULARIO AGREGAR */}
                        <form onSubmit={SubmitAllImages}>
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1">
                                            Expandir | Agregar Propiedad
                                        </a>
                                    </h4>
                                </div>
                                <div id="collapse1" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        <div className="form-group col-md-12">
                                            <div className="form-group col-md-6 text-center">
                                                <label className="radio-inline">
                                                    <input
                                                        type="radio"
                                                        id="check_arrendar"
                                                        name="opcion_inmueble"
                                                        checked={tipoOp === 'ARRIENDO'}
                                                        onChange={() => setTipoOp('ARRIENDO')}
                                                    /> <b>ARRIENDO</b>
                                                </label>
                                            </div>
                                            <div className="form-group col-md-6 text-center">
                                                <label className="radio-inline">
                                                    <input
                                                        type="radio"
                                                        id="check_vender"
                                                        name="opcion_inmueble"
                                                        checked={tipoOp === 'VENTA'}
                                                        onChange={() => setTipoOp('VENTA')}
                                                    /> <b>VENTA</b>
                                                </label>
                                            </div>
                                        </div>

                                        {/* Campo Tipo de Inmueble */}
                                        <div className="form-group col-md-4">
                                            <div className="input-group">
                                                <select name="tipo_inmueble" className="form-control" defaultValue="">
                                                    <option value="" disabled>Tipo de Inmueble</option>
                                                    {listaTipos.map(tipo => (
                                                        <option key={tipo} value={tipo}>{tipo}</option>
                                                    ))}
                                                </select>
                                                <div className="input-group-append" style={{ display: 'flex', marginTop: '5px', gap: '5px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nuevo tipo..."
                                                        value={nuevoTipo}
                                                        onChange={(e) => setNuevoTipo(e.target.value)}
                                                    />
                                                    <button type="button" className="btn btn-success" onClick={agregarTipo} title="Agregar">+</button>
                                                    <button type="button" className="btn btn-danger" onClick={eliminarTipo} title="Eliminar">-</button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Campo Municipios */}
                                        <div className="form-group col-md-4">
                                            <div className="input-group">
                                                <select name="municipio" className="form-control" defaultValue="">
                                                    <option value="" disabled>Municipios</option>
                                                    {listaMunicipios.map(muni => (
                                                        <option key={muni} value={muni}>{muni}</option>
                                                    ))}
                                                </select>
                                                <div className="input-group-append" style={{ display: 'flex', marginTop: '5px', gap: '5px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nuevo municipio..."
                                                        value={nuevoMunicipio}
                                                        onChange={(e) => setNuevoMunicipio(e.target.value)}
                                                    />
                                                    <button type="button" className="btn btn-success" onClick={agregarMunicipio} title="Agregar">+</button>
                                                    <button type="button" className="btn btn-danger" onClick={eliminarMunicipio} title="Eliminar">-</button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Campo Barrios */}
                                        <div className="form-group col-md-4">
                                            <div className="input-group">
                                                <select name="barrio" className="form-control" defaultValue="">
                                                    <option value="" disabled>Barrios</option>
                                                    {listaBarrios.map(barrio => (
                                                        <option key={barrio} value={barrio}>{barrio}</option>
                                                    ))}
                                                </select>
                                                <div className="input-group-append" style={{ display: 'flex', marginTop: '5px', gap: '5px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nuevo barrio..."
                                                        value={nuevoBarrio}
                                                        onChange={(e) => setNuevoBarrio(e.target.value)}
                                                    />
                                                    <button type="button" className="btn btn-success" onClick={agregarBarrio} title="Agregar">+</button>
                                                    <button type="button" className="btn btn-danger" onClick={eliminarBarrio} title="Eliminar">-</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group col-md-3">
                                            <select name="habitaciones" className="form-control" defaultValue="" required>
                                                <option value="" disabled>Habitaciones</option>
                                                {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                            </select>
                                        </div>

                                        <div className="form-group col-md-3">
                                            <select name="banos" className="form-control" defaultValue="" required>
                                                <option value="" disabled>Baños</option>
                                                {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                            </select>
                                        </div>

                                        <div className="form-group col-md-3">
                                            <select name="parqueadero" className="form-control" defaultValue="" required>
                                                <option value="" disabled>Parqueadero</option>
                                                {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                            </select>
                                        </div>

                                        <div className="form-group col-md-3">
                                            <input type="number" name="area" className="form-control" placeholder="Área (mts)" min="0" step="any" required />
                                        </div>

                                        <div className="form-group col-md-3">
                                            <input type="text" name="precio" className="form-control" placeholder="Precio" inputMode="numeric" value={valor} onChange={handleChangePrecio} required />
                                        </div>

                                        <div className="form-group col-md-3">
                                            <input type="number" name="codigo" className="form-control" placeholder="Código (Inmueble)" min="0" required />
                                        </div>

                                        <div className="form-group col-md-12">
                                            <textarea className="form-control" name="descripcion" style={{ height: '120px' }} rows="3" maxLength="600" placeholder="Descripción (máximo 600 caracteres)" required />
                                        </div>

                                        <div className="form-group col-md-12 text-center">
                                            <br />
                                            <label style={{ display: 'block', textAlign: 'left' }}>Imagen Principal:</label>
                                            <input name="imagen_principal" type="file" accept="image/*" className="form-control" onChange={selectedMainPhoto} required />
                                            <br />
                                            <label style={{ display: 'block', textAlign: 'left' }}>Resto de las Imágenes:</label>
                                            <input name="imagen_resto" type="file" accept="image/*" className="form-control" multiple onChange={selectedMultiples} required />
                                            <br /><br />
                                            <button type="submit" className="btn btn-primary" disabled={loading} style={{ height: '50px', width: '50%' }}>
                                                {loading ? 'Procesando y Guardando...' : 'Guardar Propiedad'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <br />

                        {/* TABLA VER PROPIEDADES */}
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h4 className="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapse2" onClick={handleTable}>
                                        Expandir | Modificar Propiedad
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse2" className="panel-collapse collapse">
                                <div className="panel-body">
                                    <div className="table-responsive" style={{ width: "100%", overflowX: "auto" }}>
                                        <table className="table table-hover table-bordered border-primary" style={{ minWidth: "1200px" }}>
                                            <thead className="thead-dark">
                                                <tr style={{ background: "#b83535", color: "white" }}>
                                                    <th>Editar</th>
                                                    <th scope="col">Código</th>
                                                    <th scope="col">Opción</th>
                                                    <th scope="col">Tipo</th>
                                                    <th scope="col">Municipios</th>
                                                    <th scope="col">Barrios</th>
                                                    <th scope="col">Habitaciones</th>
                                                    <th scope="col">Baños</th>
                                                    <th scope="col">Parqueadero</th>
                                                    <th scope="col">Área</th>
                                                    <th scope="col">Precio</th>
                                                    <th scope="col">Descripción</th>
                                                    <th>Eliminar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listInmueble.map((Inmueble, idx) => (
                                                    <tr key={Inmueble.CODIGO_INMUEBLE || idx}>
                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                            <img
                                                                onClick={() => openEditModal(Inmueble)}
                                                                src="../imagesmain/edit.png"
                                                                alt="Editar"
                                                                style={{ cursor: 'pointer', width: "24px", height: "auto" }}
                                                            />
                                                        </td>
                                                        <td>{Inmueble.CODIGO_INMUEBLE}</td>
                                                        <td>{Inmueble.OPCION_INMUEBLE}</td>
                                                        <td>{Inmueble.TIPO_INMUEBLE}</td>
                                                        <td>{Inmueble.MUNICIPIO}</td>
                                                        <td>{Inmueble.BARRIO}</td>
                                                        <td>{Inmueble.HABITACIONES}</td>
                                                        <td>{Inmueble.BANOS}</td>
                                                        <td>{Inmueble.PARQUEADERO}</td>
                                                        <td>{Inmueble.AREA}</td>
                                                        <td>{Inmueble.PRECIO}</td>
                                                        <td style={{ maxWidth: "250px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {Inmueble.DESCRIPCION}
                                                        </td>
                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                            <img
                                                                onClick={() => clickDelete(Inmueble.CODIGO_INMUEBLE)}
                                                                src="../imagesmain/trash.png"
                                                                alt="Eliminar"
                                                                style={{ cursor: 'pointer', width: "24px", height: "auto" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* MODAL ESTRUCTURADO PARA EDITAR PROPIEDAD */}
            {inmuebleEditar && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    overflowY: 'auto'
                }}>
                    <div className="panel panel-primary" style={{ width: '90%', maxWidth: '850px', margin: '20px auto', backgroundColor: '#fff', borderRadius: '8px', padding: '20px' }}>
                        <div className="panel-heading" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 className="panel-title" style={{ margin: 0, fontSize: '18px' }}>
                                Modificar Propiedad (Código: {inmuebleEditar.CODIGO_INMUEBLE})
                            </h3>
                            <button
                                type="button"
                                className="close"
                                style={{ fontSize: '24px', cursor: 'pointer', border: 'none', background: 'none' }}
                                onClick={() => setInmuebleEditar(null)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="panel-body">
                            <form onSubmit={clickEditable}>
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label>Opción:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.OPCION_INMUEBLE || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, OPCION_INMUEBLE: e.target.value })}
                                            required
                                        >
                                            <option value="ARRIENDO">ARRIENDO</option>
                                            <option value="VENTA">VENTA</option>
                                        </select>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Tipo de Inmueble:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.TIPO_INMUEBLE || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, TIPO_INMUEBLE: e.target.value })}
                                            required
                                        >
                                            <option value="" disabled>Seleccione Tipo</option>
                                            {listaTipos.map((tipo, idx) => (
                                                <option key={idx} value={tipo}>{tipo}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Municipio:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.MUNICIPIO || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, MUNICIPIO: e.target.value })}
                                            required
                                        >
                                            <option value="" disabled>Seleccione Municipio</option>
                                            {listaMunicipios.map((muni, idx) => (
                                                <option key={idx} value={muni}>{muni}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Barrio:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.BARRIO || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, BARRIO: e.target.value })}
                                            required
                                        >
                                            <option value="" disabled>Seleccione Barrio</option>
                                            {listaBarrios.map((barrio, idx) => (
                                                <option key={idx} value={barrio}>{barrio}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Habitaciones:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.HABITACIONES || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, HABITACIONES: e.target.value })}
                                        >
                                            {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Baños:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.BANOS || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, BANOS: e.target.value })}
                                        >
                                            {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Parqueadero:</label>
                                        <select
                                            className="form-control"
                                            value={inmuebleEditar.PARQUEADERO || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, PARQUEADERO: e.target.value })}
                                        >
                                            {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].map(v => <option key={v} value={v}>{v}</option>)}
                                        </select>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Área (mts):</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={inmuebleEditar.AREA || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, AREA: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label>Precio:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={inmuebleEditar.PRECIO || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, PRECIO: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-12">
                                        <label>Descripción:</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={inmuebleEditar.DESCRIPCION || ''}
                                            onChange={(e) => setInmuebleEditar({ ...inmuebleEditar, DESCRIPCION: e.target.value })}
                                            required
                                        />
                                    </div>

                                    <div className="form-group col-md-12 text-right" style={{ marginTop: '15px' }}>
                                        <button type="button" className="btn btn-default" onClick={() => setInmuebleEditar(null)} style={{ marginRight: '10px' }}>
                                            Cancelar
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            Guardar Cambios
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
}

export default AdminPropiedad;